<script lang="ts">
export default {
    name: "OperationConsole",
};
</script>
<script setup lang="ts">
import { store } from "@/store"
import type { FormInstance } from 'element-plus'
import { onBeforeUnmount, onMounted } from 'vue'

import { postDrcEnter, postDrcExit, getShoutList, speakerAudioPlayStart, speakerPlayStop, addSpeaker, modifySpeaker, speakerInfo } from "@/api/monitorApi/drc"
import { useMqtt, DeviceTopicInfo } from './use-mqtt'
import { ControlSource } from "@/types/enum"
import { postFlightAuth } from "@/api/drone-control/drone"
import { useManualControl, KeyCode } from './use-manual-control'
import { useDroneControl } from './use-drone-control'
import { noDebugCmdList as baseCmdList, DeviceCmdItem, DeviceCmd } from '@/types/device-cmd'
import { useDockControl } from './use-dock-control'
import { usePayloadControl } from './use-payload-control'
import { DeviceOsdCamera } from '@/types/device'
import { useDeviceSetting } from './use-device-setting'
import { useConnectMqtt } from './use-connect-mqtt'

const { flyToPoint, stopFlyToPoint, takeoffToPoint } = useDroneControl()

const props = defineProps<{
    deviceInfo: any
    payloadIndex: any
}>()

// 更新设备属性
const {
    genDevicePropsBySettingKey,
    setDeviceProps,
} = useDeviceSetting()

const payloadList = ref([
    { label: '无人机夜航灯', status: props.deviceInfo.device?.night_lights_state ? '开启' : '关闭', operateText: props.deviceInfo.device?.night_lights_state ? '关闭' : '开启', name: 'night_lights_state', value: props.deviceInfo.device?.night_lights_state ? props.deviceInfo.device?.night_lights_state : 0, loading: false },
    { label: '无人机喊话器', status: '关闭', operateText: '开启', name: '', value: false, loading: false },
])

const openValue = ref(false)
const keyboardActive = ref(false)

// 无人机状态
const modeCode: any = computed(() => store.other.useMyStore().deviceState.deviceInfo[store.informationListStore.informationStore().uavObj?.childSn]?.mode_code)

const controlStatus = ref(true)

const clientId = computed(() => {
    return store.other.useMyStore().clientId
})

const jitingBtn = () => {
    if (openValue.value) {
        exitFlightCOntrol()
        return
    } else {
        enterFlightControl()
        openValue.value = false
    }
}

const handleChange = () => {
    if (openValue.value) {
        enterFlightControl()
        openValue.value = false
    } else {
        exitFlightCOntrol()
        return
    }
}

const deviceTopicInfo: DeviceTopicInfo = reactive({
    sn: store.informationListStore.informationStore().airNumberValue,
    pubTopic: '',
    subTopic: ''
})

useMqtt(deviceTopicInfo)

const {
    activeCodeKey,
    handleKeyup,
    handleEmergencyStop,
    resetControlState,
    continueEmergencyStop
} = useManualControl(deviceTopicInfo, openValue, keyboardActive)

function flightControllerHandle(type: KeyCode) {
    const keyCode = handleKeyup(type)
    // if (keyCode) {
    // isActive.value = keyCode
    // }
}


// 进入飞行控制
async function enterFlightControl() {
    console.log(clientId.value)
    let params: any = {}
    params.workspaceId = localStorage.getItem("Workspace_id")
    try {
        const result = await postDrcEnter(params, {
            clientId: clientId.value,
            dockSn: store.informationListStore.informationStore().airNumberValue,
            expireSec: 3600
        })
        console.log(result)
        openValue.value = true
        if (result.sub && result.sub.length > 0) {
            deviceTopicInfo.subTopic = result.sub[0]
        }
        if (result.pub && result.pub.length > 0) {
            deviceTopicInfo.pubTopic = result.pub[0]
        }
        // 获取飞行控制权
        await postFlightAuth(store.informationListStore.informationStore().airNumberValue)
        localStorage.setItem("controlObj", JSON.stringify({
            flightController: openValue.value,
            subTopic: deviceTopicInfo.subTopic,
            pubTopic: deviceTopicInfo.pubTopic
        }))
        ElMessage.success('获取无人机远程控制')
        keyboardActive.value = true
        controlStatus.value = false
    } catch (error: any) {
    }
}

// 退出飞行控制
async function exitFlightCOntrol() {
    let params: any = {}
    try {
        const result = await postDrcExit({
            clientId: clientId.value,
            dockSn: store.informationListStore.informationStore().airNumberValue,
            expireSec: 1800
        })
        openValue.value = false
        keyboardActive.value = false
        deviceTopicInfo.subTopic = ''
        deviceTopicInfo.pubTopic = ''
        localStorage.setItem("controlObj", JSON.stringify({
            flightController: openValue.value,
            subTopic: deviceTopicInfo.subTopic,
            pubTopic: deviceTopicInfo.pubTopic
        }))
        ElMessage.success('退出无人机远程控制')
    } catch (error: any) {
    }
}

const drcState = computed(() => {
    return store.other.useMyStore().deviceState.dockInfo[store.informationListStore.informationStore().uavObj?.deviceSn]?.basicOsd
}) as any

const checked = ref()
const ruleFormRef = ref<FormInstance>()
const MAX_SPEED = 14
const flyValue = ref(false)
const flyForm: any = ref({
    securityTakeoffHeight: null as null | number,
    height: null as null | number,
    rthAltitude: null as null | number,
    rcLostAction: null as null | number,
    maxSpeed: MAX_SPEED,
    exitWaylineWhenRcLost: 1,
    latitude: drcState.value?.latitude as null | number,
    longitude: drcState.value?.longitude as null | number,
})

const rules = reactive({
    securityTakeoffHeight: [
        { required: true, message: '请输入安全离场高度', trigger: 'blur' },
    ],
    height: [
        { required: true, message: '请输入飞行作业高度', trigger: 'blur' },
    ],
    rthAltitude: [
        { required: true, message: '请输入返航高度', trigger: 'blur' },
    ],
    rcLostAction: [
        { required: true, message: '请选择失联动作', trigger: 'blur' },
    ],
})

//起飞
const submitForm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return
    await formEl.validate((valid, fields) => {
        if (valid) {
            takeoffToPoint(store.informationListStore.informationStore().airNumberValue, {
                target_latitude: flyForm.value.latitude,
                target_longitude: flyForm.value.longitude,
                target_height: flyForm.value.height,
                security_takeoff_height: flyForm.value.securityTakeoffHeight,
                rth_altitude: flyForm.value.rthAltitude,
                max_speed: flyForm.value.maxSpeed,
                rc_lost_action: flyForm.value.rcLostAction,
                exit_wayline_when_rc_lost: flyForm.value.exitWaylineWhenRcLost
            })
            flyValue.value = false
        } else {
            console.log('error submit!', fields)
        }
    })
}

const initCmdList = baseCmdList.find(item => item.cmdKey === DeviceCmd.ReturnHome) as DeviceCmdItem
const cmdItem = ref(initCmdList)
const {
    sendDockControlCmd
} = useDockControl()
// 返航
async function sendControlCmd(cmdItem: DeviceCmdItem, index: number) {
    cmdItem.loading = true
    const result = await sendDockControlCmd({
        sn: store.informationListStore.informationStore().airNumberValue,
        cmd: cmdItem.cmdKey,
        action: cmdItem.action
    }, false)
    cmdItem.loading = false
}

// 停止飞往目标点
async function onStopFlyToPoint() {
    await stopFlyToPoint(store.informationListStore.informationStore().airNumberValue)
}


const {
    resetGimbal
} = usePayloadControl()
// 负载控制
const payloadSelectInfo = {
    value: null as any,
    controlSource: undefined as undefined | ControlSource,
    options: [] as any,
    payloadIndex: '' as string,
    camera: undefined as undefined | DeviceOsdCamera // 当前负载osd信息
}


const flyBtn = () => {
    flyValue.value = true
}

const closeDialog = () => {
    flyValue.value = false
}

async function onConfirm(settingKey: any) {
    // 无人机夜航灯
    if (settingKey === 'night_lights_state') {
        payloadList.value[0].loading = true
        const body = genDevicePropsBySettingKey(settingKey, payloadList.value[0].value as any)
        const res = await setDeviceProps(store.informationListStore.informationStore().airNumberValue, body)
        console.log(body)
        console.log(res)
        if (res) {
            payloadList.value[0].value = !payloadList.value[0].value
            payloadList.value[0].status = payloadList.value[0].value ? '开启' : '关闭'
            payloadList.value[0].operateText = payloadList.value[0].value ? '关闭' : '开启'
        }
        payloadList.value[0].loading = false
    } else { // 无人机喊话器,无请求，前端开启关闭
        payloadList.value[1].loading = true
        payloadList.value[1].value = !payloadList.value[1].value
        payloadList.value[1].status = payloadList.value[1].value ? '开启' : '关闭'
        payloadList.value[1].operateText = payloadList.value[1].value ? '关闭' : '开启'
        payloadList.value[1].loading = false
    }
}

const shoutActive = ref(false)
const shoutList = ref()
const shoutBtn = () => {
    shoutActive.value = true
    getShoutList({
        page: 1,
        size: 999
    }).then((res) => {
        shoutList.value = res.list
    })
}
const shoutValue = ref()
const shoutObject = ref()
const selectShoutBtn = (list: any, i: any) => {
    shoutObject.value = list
    shoutValue.value = i
}

const saveBtn = () => {
    let params: any = {}
    params.deviceSn = shoutObject.value.deviceSn
    params.contentId = shoutObject.value.contentId
    params.content = shoutObject.value.content
    addSpeaker(params).then((res) => {
        ElMessage.success("保存成功")
        shoutActive.value = false
    })
}

const cancelBtn = () => {
    shoutActive.value = false
}

const shoutObj = ref()
const shoutgif = ref(false)
const startShout = async () => {
    await speakerInfo(store.informationListStore.informationStore().uavObj?.deviceSn).then((res) => {
        console.log(res)
        shoutObj.value = res
    })
    await speakerAudioPlayStart({
        playMode: cycleValue.value,
        content: shoutObj.value.content,
        contentId: shoutObj.value.contentId,
        deviceSn: store.informationListStore.informationStore().uavObj?.deviceSn
    }).then((res) => {
        ElMessage.success("喊话成功")
        if (cycleValue.value == 0) {
            shoutgif.value = true
            setTimeout(() => {
                shoutgif.value = false
            }, 2000)
        } else {
            shoutgif.value = true
        }
    })
}

const stopShout = () => {
    speakerPlayStop({
        deviceSn: store.informationListStore.informationStore().uavObj?.deviceSn
    }).then((res) => {
        ElMessage.success("停止喊话")
        shoutgif.value = false
    })
}

const cycleValue = ref(0)
const cycleBtn = () => {
    if (cycleValue.value == 0) {
        cycleValue.value = 1
    } else {
        cycleValue.value = 0
    }
}

useConnectMqtt()

const onEscapeCloseKeyboard = (e: KeyboardEvent) => {
    if (e.keyCode === 27 && keyboardActive.value) {
        keyboardActive.value = false
    }
}

onMounted(() => {
    if (store.informationListStore.informationStore().controlObj && Object.keys(store.informationListStore.informationStore().controlObj).length) {
        deviceTopicInfo.subTopic = JSON.parse(store.informationListStore.informationStore().controlObj).subTopic
        deviceTopicInfo.pubTopic = JSON.parse(store.informationListStore.informationStore().controlObj).pubTopic
    }
    window.addEventListener('keydown', onEscapeCloseKeyboard)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', onEscapeCloseKeyboard)
})
const deviceInfo1 = computed(() => store.other.useMyStore().deviceState.deviceInfo ?? {})

watch(() => deviceInfo1.value, (newVal, oldVal) => {
    //   console.log(newVal,store.informationListStore.informationStore().airNumberValue,store.informationListStore.informationStore().uavObj)
    //   if(Object.keys(newVal).length){
    //     console.log(newVal[store.informationListStore.informationStore().uavObj?.childSn])
    //   }
    //   if(oldVal && Object.keys(oldVal).length){
    //     console.log(oldVal[store.informationListStore.informationStore().uavObj?.childSn])
    //   }
    if (Object.keys(newVal).length && oldVal && Object.keys(oldVal).length) {
        payloadSelectInfo.payloadIndex = newVal[store.informationListStore.informationStore().uavObj?.childSn]?.payload[0]?.payload_index || ''
        if (newVal[store.informationListStore.informationStore().uavObj?.childSn]?.mode_code !== oldVal[store.informationListStore.informationStore().uavObj?.childSn]?.mode_code) {
            if (newVal[store.informationListStore.informationStore().uavObj?.childSn].mode_code == 3 || newVal[store.informationListStore.informationStore().uavObj?.childSn].mode_code == 16) {
                console.log("modecode =3", newVal[store.informationListStore.informationStore().uavObj?.childSn].mode_code, localStorage.getItem("treatValue"))
                openValue.value = true
                if (localStorage.getItem("treatValue") && newVal[store.informationListStore.informationStore().uavObj?.childSn].mode_code == 3 && controlStatus.value) {
                    enterFlightControl()
                    return
                }
            } else {
                openValue.value = false
                // exitFlightCOntrol()
            }
        }
    }

}, {
    deep: true,
    immediate: true
})

</script>

<template>
    <div class="operationConsole-box">
        <div class="jiting" @click="jitingBtn" :style="openValue ? 'top: -6.1vh;' : 'top:11.1vh;'">
            <img src="@/assets/icons/jjst.png" alt="" v-if="!openValue">
            <img src="@/assets/icons/yxt.png" alt="" v-else>
        </div>

        <div class="fanhang" :style="openValue ? 'top: -5.7vh;' : 'top:11.5vh;'" @click="sendControlCmd(cmdItem, 0)">
            <p>返航</p>
        </div>
        <!-- <div style="position: absolute;right: 20px;width: 220px;height: 170px; background: #12233A;border-radius: 5px 5px 5px 5px;display: flex;flex-direction: column;align-items: center;"
            :style="openValue ? 'top: -185px;' : 'top: -12.4rem;'">
            <div style="display: flex;align-items: center;cursor: pointer;" @click="cycleBtn">
                <p style="margin-top: 20px;">
                    <img src="@/assets/images/weidianji.png" alt="" v-if="!cycleValue">
                    <img src="@/assets/images/dianji.png" alt="" v-else>
                </p>
                <p style="color: #fff;margin-left: 10px;font-size: 12px;line-height: 10px;margin-top: 15px;">
                    循环播放</p>
            </div>
            <div style="display: flex;">
                <div style="cursor: pointer;position: relative;">
                    <img title="喊话" @click="startShout" src="@/assets/images/hanhua.png" alt="">
                    <p style="text-align: center;font-size: 12px;color: #CECECE;">喊话</p>
                    <p style="width: 30px;height: 40px;position: absolute;top: 10px;left: 50px;" v-if="shoutgif">
                        <img src="@/assets/images/shout-gif.gif" alt="" style="width: 30px;height: 40px;">
                    </p>
                </div>
                <div style="cursor: pointer;">
                    <img title="停止喊话" @click="stopShout" src="@/assets/images/tingzhihanhua.png" alt="">
                    <p style="text-align: center;font-size: 12px;color: #CECECE;">停止喊话</p>
                </div>
            </div>
            <div style="display: flex;align-items: center;cursor: pointer;">
                <div style="font-size: 16px;color: #00FCFF;text-align: center;margin-top: 10px;text-decoration: underline;cursor: pointer;"
                    @click="shoutBtn">喊话内容选择</div>
            </div>
        </div> -->
        <!-- <div class="uav-control">
            <div @click="setUpBtn">
                <img src="@/assets/images/shezhi.png" alt="">
            </div>
            <div v-if="setupActive" class="uav-btn-list">
                <p v-for="item in payloadList" :key="item.name" @click="onConfirm(item.name)">
                    {{ item.label }}
                    <span style="color: rgba(255, 255, 255, 0.6);font-weight: 400;">{{ item.status }}</span>
                </p>
                <p @click="resetbtn(0)">云台回中</p>
                <p @click="resetbtn(1)">云台向下</p>
            </div>
        </div> -->
        <div class="open-box">
            <el-form>
                <el-form-item label="摇杆/挂载控制" label-position="left">
                    <el-switch v-model="openValue" inline-prompt active-text="开" inactive-text="关"
                        @change="handleChange" />
                </el-form-item>
            </el-form>
        </div>
        <div class="bottom-box" v-if="openValue">
            <div class="control-box">
                <div style="display: flex;margin-left: 1vw;margin-top: 3.8vh;">
                    <div class="left-word"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div
                            style="margin-left: 3.6vw;width: 2.2vw;height: 1.4vh;font-size: .625rem;color: #FFFFFF;background: #040F1A;text-align: center;border-radius: 6px;line-height: 1.2vh;margin-top: 4.7vh;font-family: AlibabaPuHuiTi;">
                            左旋(A)</div>
                    </div>
                    <div class="left-control-box"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div class="control-ground">
                            <div class="img-up" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.KEY_W)">
                                <img src="@/assets/icons/top-control.png" alt="" v-if="activeCodeKey != 'KeyW'">
                                <img src="@/assets/icons/top-control-active.png" alt="" v-if="activeCodeKey == 'KeyW'">
                            </div>
                            <div class="img-down" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.KEY_S)">
                                <img src="@/assets/icons/bottom-control.png" alt="" v-if="activeCodeKey != 'KeyS'">
                                <img src="@/assets/icons/bottom-control-active.png" alt=""
                                    v-if="activeCodeKey == 'KeyS'">
                            </div>
                            <div class="img-left" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.KEY_A)">
                                <img src="@/assets/icons/left-control.png" alt="" v-if="activeCodeKey != 'KeyA'">
                                <img src="@/assets/icons/left-control-active.png" alt="" v-if="activeCodeKey == 'KeyA'">
                            </div>
                            <div class="img-right" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.KEY_D)">
                                <img src="@/assets/icons/right-control.png" alt="" v-if="activeCodeKey != 'KeyD'">
                                <img src="@/assets/icons/right-control-active.png" alt=""
                                    v-if="activeCodeKey == 'KeyD'">
                            </div>
                        </div>
                    </div>
                    <div class="left-word"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div
                            style="width: 2.4vw;height: 1.4vh;font-size: .625rem;color: #FFFFFF;background: #040F1A;text-align: center;border-radius: 6px;line-height: 1.2vh;margin-top: 4.7vh;font-family: AlibabaPuHuiTi;">
                            右旋(D)</div>
                    </div>
                </div>

                <div style="display: flex;margin-left:2.9vw;margin-top: 3.8vh;">
                    <div class="right-word"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div
                            style="width: 2.2vw;height: 1.4vh;font-size: .625rem;color: #FFFFFF;background: #040F1A;text-align: center;border-radius: 6px;line-height: 1.2vh;margin-top: 4.7vh;font-family: AlibabaPuHuiTi;">
                            左移(←)</div>
                    </div>
                    <div class="right-control-box"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div class="control-ground">
                            <div class="img-up" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.ARROW_UP)">
                                <img src="@/assets/icons/qj-control.png" alt="" v-if="activeCodeKey != 'ArrowUp'">
                                <img src="@/assets/icons/qj-control-active.png" alt=""
                                    v-if="activeCodeKey == 'ArrowUp'">
                            </div>
                            <div class="img-down" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.ARROW_DOWN)">
                                <img src="@/assets/icons/ht-control.png" alt="" v-if="activeCodeKey != 'ArrowDown'">
                                <img src="@/assets/icons/ht-control-active.png" alt=""
                                    v-if="activeCodeKey == 'ArrowDown'">
                            </div>
                            <div class="img-left" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.ARROW_LEFT)">
                                <img src="@/assets/icons/zuo-control.png" alt="" v-if="activeCodeKey != 'ArrowLeft'">
                                <img src="@/assets/icons/zuo-control-active.png" alt=""
                                    v-if="activeCodeKey == 'ArrowLeft'">
                            </div>
                            <div class="img-right" @mouseup="resetControlState"
                                @mousedown="flightControllerHandle(KeyCode.ARROW_RIGHT)">
                                <img src="@/assets/icons/you-control.png" alt="" v-if="activeCodeKey != 'ArrowRight'">
                                <img src="@/assets/icons/you-control-active.png" alt=""
                                    v-if="activeCodeKey == 'ArrowRight'">
                            </div>
                        </div>
                    </div>
                    <div class="right-word"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <div
                            style="width: 2.4vw;height: 1.4vh;font-size: .625rem;color: #FFFFFF;background: #040F1A;text-align: center;border-radius: 6px;line-height: 1.2vh;margin-top: 4.7vh;font-family: AlibabaPuHuiTi;">
                            右移(→)</div>
                    </div>
                </div>
                <div class="left-manual-box">
                    <div class="manual-list" @click="flyBtn"
                        :style="[1, 2, 3, 5, 16].includes(modeCode) ? 'opacity:0.5;pointer-events:none;' : 'opacity:1;pointer-events:auto;'">
                        <p>起飞悬停</p>
                    </div>
                    <!-- <div class="manual-list" @click="sendControlCmd(cmdItem, 0)"
                        :style="[3, 5, 16].includes(modeCode) ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <p>返航</p>
                    </div> -->
                    <!-- <div class="manual-list"
                        :style="openValue ? 'opacity:1;pointer-events:auto;' : 'opacity:0.5;pointer-events:none;'">
                        <p>指点飞行</p>
                    </div> -->
                </div>
                <!-- <div class="line-box"></div> -->
                <!-- <div class="right-manual-box">
                    <div class="right-manual">
                        <div style="display: flex;">
                            <div>
                                <img title="回中" @click="resetbtn(0)" src="@/assets/icons/huizhong.png" alt="">
                                <p>云台回中</p>
                            </div>
                            <div style="margin-left: 2.8vw;">
                                <img title="向下" @click="resetbtn(1)" src="@/assets/icons/xiangxia.png" alt="">
                                <p>云台朝下</p>
                            </div>
                        </div>
                        <div style="display: flex;margin-top: 1.1vh;">
                            <div style="cursor: pointer;position: relative;">
                                <img title="喊话" @click="startShout" src="@/assets/icons/hanhua.png" alt="">
                                <p>喊话</p>
                                <p style="width: 1.6vw;height: 3.7vh;position: absolute;top: -0.3vh;left: 1.6vw;"
                                    v-if="shoutgif">
                                    <img src="@/assets/images/shout-gif.gif" alt="" style="width: 30px;height: 40px;">
                                </p>
                            </div>
                            <div style="cursor: pointer;margin-left: 2.8vw;">
                                <img title="停止喊话" @click="stopShout" src="@/assets/icons/tzhh.png" alt="">
                                <p>停止喊话</p>
                            </div>
                        </div>

                    </div>
                    <div>
                        <div style="display: flex;align-items: center;margin-left: 3.2vw;height: 1.7vh;margin-top: 4.1vh;"
                            @click="cycleBtn">
                            <p style="color: #fff;font-size: .75rem;line-height: 10px;font-family: AlibabaPuHuiTi;">
                                循环播放</p>
                            <p style="margin-left: .4vw;width: 0.9vw;height: 1.7vh;">
                                <img style="width: 0.9vw;height: 1.7vh;" src="@/assets/icons/weidianji.png" alt=""
                                    v-if="!cycleValue">
                                <img style="width: 0.9vw;height: 1.7vh;" src="@/assets/icons/dianji.png" alt="" v-else>
                            </p>
                        </div>
                        <div style="font-size: .75rem;color: #0BE8F6;margin-left: 3vw;margin-top: 1.4vh;text-decoration: underline;cursor: pointer;font-family: AlibabaPuHuiTi;"
                            @click="shoutBtn">喊话内容选择</div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

    <!-- 喊话弹窗 -->
    <div class="shoutDialog" v-if="shoutActive">
        <div style="position: relative;">
            <div class="closeBtn" @click="cancelBtn">
                <img src="@/assets/icons/close-btn.png" alt="">
            </div>
        </div>
        <div
            style="font-family: YouSheBiaoTiHei;font-size: 1.125rem;color: #FFFFFF;text-shadow: 0px 0.8px 1.88px rgba(0, 253, 255, 0.502);margin: 11px 0 0 23px;">
            喊话器内容选择：</div>
        <div class="selectBox">
            <div class="selectlist" v-for="(item, index) in shoutList" @click="selectShoutBtn(item, index)">
                <p>
                    <img src="@/assets/icons/weixuanze.png" alt="" v-if="shoutValue != index">
                    <img src="@/assets/icons/yixuanze.png" alt="" v-else>
                </p>
                <p>{{ item.content }}</p>
            </div>
        </div>
        <div class="saveBtn">
            <p class="cancel" @click="cancelBtn">取消</p>
            <p class="save" @click="saveBtn">确认</p>
        </div>
    </div>

    <el-dialog class="flyDialogBox" destroy-on-close v-model="flyValue" title="起飞弹窗" @close="closeDialog" draggable>
        <el-form :model="flyForm" ref="ruleFormRef" label-width="auto" class="flyform" :rules="rules">
            <el-form-item label="安全离场高(ALT):" prop="securityTakeoffHeight">
                <el-input-number v-model="flyForm.securityTakeoffHeight" :min="1.5" :max="1500" style="width: 18rem;"
                    controls-position="right" />
            </el-form-item>
            <el-form-item label="飞行作业高(AGL):" prop="height">
                <el-input-number v-model="flyForm.height" :min="1.5" :max="1500" style="width: 18rem;"
                    controls-position="right" />
            </el-form-item>
            <el-form-item label="返航高(RTH):" prop="rthAltitude">
                <el-input-number v-model="flyForm.rthAltitude" :min="1" style="width: 18rem;"
                    controls-position="right" />
            </el-form-item>
            <el-form-item label="失联动作:" prop="rcLostAction">
                <el-select v-model="flyForm.rcLostAction" placeholder="请选择失联动作">
                    <el-option label="返航" :value="2" />
                    <el-option label="悬停" :value="0" />
                    <el-option label="着陆" :value="1" />
                </el-select>
            </el-form-item>
            <div style="text-align: center;">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">确认</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<style scoped lang="scss">
.operationConsole-box {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    width: 46.7vw;
    height: 19vh;
    z-index: 1;
    pointer-events: none;

    .jiting {
        width: 5.9vw;
        height: 4.6vh;
        position: absolute;
        top: -6.1vh;
        color: #fff;
        cursor: pointer;
        pointer-events: all;

        img {
            width: 5.9vw;
            height: 4.6vh;
        }
    }

    .fanhang {
        width: 6.5vw;
        height: 3.7vh;
        background: url("@/assets/icons/cmd-bj.png") no-repeat center;
        background-size: cover;
        cursor: pointer;
        pointer-events: all;
        line-height: 3.8vh;
        position: absolute;
        top: -5.7vh;
        left: 6.2vw;
        p {
            font-family: YouSheBiaoTiHei;
            font-size: .875rem;
            font-weight: normal;
            margin-left: 2.6vw;
            color: #FFFFFF;
            text-shadow: 0px 0.8px 1.88px rgba(0, 253, 255, 0.502);
        }
    }

    .open-box {
        position: absolute;
        bottom: 0px;
        right: .9vw;
        pointer-events: all;

        :deep(.el-form-item__label) {
            color: #FFFFFF;
            text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.3);
            font-family: AlibabaPuHuiTi;
        }

        .el-switch {
            :deep(.el-switch__label) {
                color: #E8EBEF;
            }

            :deep(.el-switch__core) {
                background: linear-gradient(115deg, rgba(73, 73, 73, 0.83) 0%, #DCDCDC 100%);
                border: none;
            }
        }

        .el-switch.is-checked {
            :deep(.el-switch__core) {
                background: linear-gradient(115deg, rgba(64, 255, 249, 0.83) 0%, #408CFF 100%);
                border: none;
            }
        }
    }

    .bottom-box {
        width: 46.7vw;
        height: 19vh;
        background: linear-gradient(0deg, rgba(21, 31, 50, 0.464) 0%, rgba(24, 35, 58, 0.8) 97%);
        box-sizing: border-box;
        border: 1px solid;
        border-image: linear-gradient(180deg, #159AFF 12%, rgba(21, 154, 255, 0) 100%) 1;
        border-radius: 2px;
    }

    .control-box {
        display: flex;
        color: #fff;
        font-size: .625rem;

        .left-control-box {
            width: 7.6vw;
            height: 11.1vh;
            background: url("@/assets/icons/control-bj.png") no-repeat center;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .control-ground {
                position: relative;
                width: 7.6vw;
                height: 11.1vh;
            }

            .control-ground::before {
                content: "上升 (w)";
                position: absolute;
                left: 50%;
                top: -16px;
                transform: translate(-50%);
                width: 2.6vw;
                height: 1.4vh;
                text-align: center;
                font-family: AlibabaPuHuiTi;
                background: #040F1A;
                text-align: center;
                border-radius: 6px;
                line-height: 1.2vh;
            }

            .control-ground::after {
                content: "下降 (s)";
                position: absolute;
                left: 48.5%;
                bottom: -1.5vh;
                transform: translate(-50%);
                width: 2.6vw;
                height: 1.4vh;
                text-align: center;
                background: #040F1A;
                font-family: AlibabaPuHuiTi;
                text-align: center;
                border-radius: 6px;
                line-height: 1.2vh;
            }

            img {
                width: 100%;
                height: 100%;
            }

            div {
                position: absolute;
                cursor: pointer;
            }

            .img-up {
                width: 3.6vw;
                height: 3.3vh;
                top: 1.3vh;
                left: 50%;
                transform: translate(-50%);
            }

            .img-down {
                width: 3.6vw;
                height: 3.3vh;
                bottom: 1.2vh;
                left: 50%;
                transform: translate(-50%);
            }

            .img-left {
                width: 1.5vw;
                height: 5vh;
                left: 1.3vw;
                top: 50%;
                transform: translateY(-50%);
            }

            .img-right {
                width: 1.5vw;
                height: 5vh;
                right: 1.35vw;
                top: 50.5%;
                transform: translateY(-50%);
            }
        }


        .left-manual-box {
            margin-left: 2.3vw;
            margin-top: 5.2vh;

            .manual-list {
                width: 6.2vw;
                height: 3.1vh;
                background: url("@/assets/icons/cmd-bj.png") no-repeat center;
                background-size: cover;
                cursor: pointer;
                line-height: 3.5vh;
                margin-bottom: 1.4vh;

                p {
                    font-family: YouSheBiaoTiHei;
                    font-size: .875rem;
                    font-weight: normal;
                    margin-left: 2.6vw;
                    color: #FFFFFF;
                    text-shadow: 0px 0.8px 1.88px rgba(0, 253, 255, 0.502);
                }
            }
        }

        .right-control-box {
            width: 7.6vw;
            height: 11.1vh;
            background: url("@/assets/icons/control-bj.png") no-repeat center;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .control-ground {
                position: relative;
                width: 7.6vw;
                height: 11.1vh;
            }

            .control-ground::before {
                content: "前进 (↑)";
                position: absolute;
                left: 50%;
                top: -16px;
                transform: translate(-50%);
                width: 2.6vw;
                height: 1.4vh;
                text-align: center;
                background: #040F1A;
                text-align: center;
                border-radius: 6px;
                line-height: 1.2vh;
                font-family: AlibabaPuHuiTi;
            }

            .control-ground::after {
                content: "后退 (↓)";
                position: absolute;
                left: 48.5%;
                bottom: -1.5vh;
                transform: translate(-50%);
                width: 2.6vw;
                height: 1.4vh;
                text-align: center;
                background: #040F1A;
                text-align: center;
                border-radius: 6px;
                line-height: 1.2vh;
                font-family: AlibabaPuHuiTi;
            }

            img {
                width: 100%;
                height: 100%;
            }

            div {
                position: absolute;
                cursor: pointer;
            }

            .img-up {
                width: 3.6vw;
                height: 3.3vh;
                top: 1.3vh;
                left: 50%;
                transform: translate(-50%);
            }

            .img-down {
                width: 3.6vw;
                height: 3.3vh;
                bottom: 1.2vh;
                left: 50%;
                transform: translate(-50%);
            }

            .img-left {
                width: 1.5vw;
                height: 5vh;
                left: 1.3vw;
                top: 50%;
                transform: translateY(-50%);
            }

            .img-right {
                width: 1.5vw;
                height: 5vh;
                right: 1.35vw;
                top: 50.5%;
                transform: translateY(-50%);
            }
        }

        .line-box {
            width: 0.2vw;
            height: 15.6vh;
            background: rgba(153, 153, 153, 0.5);
            margin-left: 2.3vw;
            margin-right: 2.3vw;
            margin-top: 1.6vh;
        }

        .right-manual-box {
            display: flex;
            pointer-events: all;

            .right-manual {
                // margin-left: 3.125rem;
                margin-top: 2.7vh;

                img {
                    width: 2.8vw;
                    height: 3.5vh;
                    // margin: 5px 10px;
                    cursor: pointer;
                }

                p {
                    font-size: .875rem;
                    line-height: 1.9vh;
                    color: #fff;
                    text-align: center;
                    font-family: AlibabaPuHuiTi;
                }
            }
        }
    }

}
</style>

